import type { ConsentState } from 'c15t';
import { emitConsentModeUpdate } from '@belong/common';
import { getConsentSnapshot } from './consent-state';
import { logConsentEvent } from './log';

export function logConsentModeError(
  mode: 'default' | 'update',
  error: unknown,
) {
  logConsentEvent('consent.error', {
    scope: 'consent-mode',
    mode,
    error: error instanceof Error ? error.message : String(error),
  });
}

export function updateConsentMode(consents: ConsentState) {
  try {
    emitConsentModeUpdate(consents, getConsentSnapshot()?.model);
  } catch (error) {
    logConsentModeError('update', error);
  }
}
